// removed by extract-text-webpack-plugin
module.exports = {"title":"passwordUpdated__title___2SwCu","login":"passwordUpdated__login___2vPet"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/auth/passwordUpdated/passwordUpdated.scss
// module id = 1248
// module chunks = 0